const downloadCSV = (data: any[][], filename: string = "data"): void => {
  if (!data || data.length === 0) {
      console.error("No data provided.");
      return;
  }

  // Find compliance percentage column indices
  const headers = data[0] || [];
  const complianceIndices = headers
    .map((h: any, i: number) => (typeof h === 'string' && h.toLowerCase().includes('compliance %') ? i : -1))
    .filter((i: number) => i !== -1);

  // Convert data array to CSV format
  const csvContent = data
      .map((row, rIdx) => row.map((cell, cIdx) => {
        let val = cell;
        if (rIdx > 0 && complianceIndices.includes(cIdx) && val !== null && val !== undefined && val !== '' && !isNaN(Number(val))) {
          val = Math.floor(Number(val));
        }
        return `"${val}"`;
      }).join(",")) // Enclose each cell in quotes
      .join("\n"); // Join rows with new lines

  // Create a Blob and trigger a download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default downloadCSV;

